import React from "react"
import { kebabCase } from "lodash"
import { Document, Page, View, Text, Link } from "@react-pdf/renderer"
import {
  Table,
  TableHeader,
  TableCell,
  TableBody,
  DataTableCell,
} from "@david.kucsai/react-pdf-table"

import { styles } from "./pdfStyles"

function generateElement(child, key, isSublist) {
  const { type } = child

  switch (type) {
    case "table":
      let headers = []
      let tableData = []
      const { children } = child
      children[0].children.forEach(ch => {
        return headers.push(ch.children[0].value)
      })
      children.slice(1).forEach(ch => {
        const tableRow = {}
        ch.children
          .map(c => c.children)
          .map((r, i) =>
            Object.assign(tableRow, {
              [kebabCase(headers[i])]:
                r[0].type === "link" ? r[0].children[0].value : r[0].value,
            })
          )
        tableData.push(tableRow)
      })
      return (
        <Table data={tableData} style={styles.table}>
          <TableHeader style={styles.tableHeader}>
            {headers.map((header, index) => (
              <TableCell
                key={index}
                style={[styles.tableCell, styles.h4, styles.bold]}
              >
                {header}
              </TableCell>
            ))}
          </TableHeader>
          <TableBody style={styles.tableBody}>
            {headers.map((header, index) => (
              <DataTableCell
                style={styles.tableCell}
                key={index}
                getContent={r => r[kebabCase(header)]}
              />
            ))}
          </TableBody>
        </Table>
      )
    case "heading":
      return (
        <Text key={key} style={[styles.heading, styles[`h${child.depth}`]]}>
          {child.children[0].value}
        </Text>
      )
    case "paragraph":
      return (
        <Text key={key} wrap styles={styles.text}>
          {child.children.length > 0 &&
            child.children.map((c, i) => generateElement(c, i, null))}
        </Text>
      )
    case "link":
      return (
        <Link key={key} src={child.url} style={styles.link}>
          {generateElement(child.children[0], null, null)}
        </Link>
      )
    case "strong":
      return (
        <Text key={key} style={styles.strong}>
          {generateElement(child.children[0], null, null)}
        </Text>
      )
    case "list":
      return (
        <View
          style={[styles.list, styles.view, { flexDirection: "column" }]}
          key={key}
        >
          {child.children &&
            child.children.map((c, i) => (
              <View
                key={i}
                style={[
                  styles.listItem,
                  { flexDirection: `${isSublist !== "true" && "row"}` },
                ]}
              >
                <Text style={{ marginLeft: "8pt", marginRight: "6pt" }}>
                  {child.ordered ? (
                    <>{`${child.start + i}.   `}</>
                  ) : (
                    <>{`*   `}</>
                  )}
                </Text>
                {isSublist === "true" ? (
                  <View style={[styles.list, { flexDirection: "column" }]}>
                    {c.children.map((cc, ii) => {
                      return <>{generateElement(cc, ii, "true")}</>
                    })}
                  </View>
                ) : (
                  <Text>
                    {c.children.map((cc, ii) => {
                      return <>{generateElement(cc, ii, "true")}</>
                    })}
                  </Text>
                )}
              </View>
            ))}
        </View>
      )
    default:
      return <Text key={key}>{child.value}</Text>
  }
}
const PdfDocument = ({ mdast }) => {
  return (
    <Document>
      <Page style={styles.page} size="A4" wrap>
        {mdast.children.map((child, key) => (
          <View key={key} style={[styles[child.type], styles.view]}>
            {generateElement(child, key, null)}
          </View>
        ))}
      </Page>
    </Document>
  )
}

export default PdfDocument
